var _path, _circle, _ellipse, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _path3, _path4, _circle3, _g, _path5, _line, _line2, _line3, _line4, _line5, _rect9, _path6, _g2, _rect10, _path7, _rect11, _rect12, _path8, _path9, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 264 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M0 97.64C-3.52863e-05 113.518 13.3141 151.436 42.1143 168.114C71.5213 185.144 96.1764 170.895 130.855 171.457C157.048 171.881 173.189 179.413 197.937 171.457C232.954 160.199 270.945 140.897 262.914 107.389C257.329 84.0868 230.73 84.465 214.182 66.1635C197.674 47.9065 199.444 29.0577 178.986 14.6312C134.702 -16.5971 80.6937 6.80152 39.407 41.3723C18.4285 58.9383 3.52865e-05 81.7623 0 97.64Z",
    fill: "#EF476F",
    fillOpacity: 0.02
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 139,
    cy: 44.6021,
    r: 30,
    stroke: "#EF476F",
    strokeOpacity: 0.2,
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 49,
    ry: 48.5,
    transform: "matrix(-1 0 0 1 73 109.102)",
    stroke: "#EF476F",
    strokeOpacity: 0.2,
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 116.602,
    r: 20,
    stroke: "#EF476F",
    strokeOpacity: 0.2,
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79.9673,
    y: 36.2556,
    width: 9.03552,
    height: 1.79535,
    transform: "rotate(-45 79.9673 36.2556)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 192.395,
    y: 67.7124,
    width: 9.03552,
    height: 1.79535,
    transform: "rotate(-45 192.395 67.7124)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 93.9473,
    y: 162.083,
    width: 9.03552,
    height: 1.79535,
    transform: "rotate(-45 93.9473 162.083)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 236.085,
    y: 135.869,
    width: 9.03552,
    height: 1.79535,
    transform: "rotate(-45 236.085 135.869)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 81.1655,
    y: 29.7092,
    width: 9.34415,
    height: 1.9218,
    transform: "rotate(45 81.1655 29.7092)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 193.595,
    y: 61.166,
    width: 9.34415,
    height: 1.9218,
    transform: "rotate(45 193.595 61.166)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 95.147,
    y: 155.536,
    width: 9.34415,
    height: 1.9218,
    transform: "rotate(45 95.147 155.536)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 237.285,
    y: 129.322,
    width: 9.34415,
    height: 1.9218,
    transform: "rotate(45 237.285 129.322)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3211 46.6027C65.3211 48.576 63.7215 50.1756 61.7482 50.1756C61.162 50.1756 60.6088 50.0345 60.1207 49.7843L64.9298 44.9752C65.18 45.4633 65.3211 46.0165 65.3211 46.6027ZM58.6321 48.352L63.4975 43.4866C62.9805 43.1957 62.3837 43.0298 61.7482 43.0298C59.7749 43.0298 58.1753 44.6294 58.1753 46.6027C58.1753 47.2382 58.3412 47.835 58.6321 48.352ZM69.3211 46.6027C69.3211 50.7851 65.9306 54.1756 61.7482 54.1756C57.5658 54.1756 54.1753 50.7851 54.1753 46.6027C54.1753 42.4203 57.5658 39.0298 61.7482 39.0298C65.9306 39.0298 69.3211 42.4203 69.3211 46.6027Z",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.809 152.041C195.809 154.014 194.209 155.614 192.236 155.614C191.65 155.614 191.097 155.473 190.608 155.222L195.418 150.413C195.668 150.902 195.809 151.455 195.809 152.041ZM189.12 153.79L193.985 148.925C193.468 148.634 192.872 148.468 192.236 148.468C190.263 148.468 188.663 150.068 188.663 152.041C188.663 152.676 188.829 153.273 189.12 153.79ZM199.809 152.041C199.809 156.223 196.418 159.614 192.236 159.614C188.054 159.614 184.663 156.223 184.663 152.041C184.663 147.859 188.054 144.468 192.236 144.468C196.418 144.468 199.809 147.859 199.809 152.041Z",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.286 35.8293C174.14 35.202 174.616 34.6021 175.26 34.6021H179.74C180.384 34.6021 180.86 35.202 180.714 35.8293L178.474 45.4284C178.233 46.4588 176.767 46.4588 176.526 45.4284L174.286 35.8293Z",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 51.6021,
    r: 2,
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24_13423)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.9385,
    y: 95.135,
    width: 73.0375,
    height: 46.1289,
    rx: 8,
    transform: "rotate(-8.69553 50.9385 95.135)",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7283 100.299C51.2921 97.447 53.2505 94.7814 56.1026 94.3452L117.972 84.8827C120.824 84.4465 123.49 86.405 123.926 89.257L124.735 94.5426L52.5367 105.585L51.7283 100.299Z",
    fill: "#FFCAD7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 94.6164,
    y1: 119.852,
    x2: 119.243,
    y2: 116.085,
    stroke: "#EF476F",
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 93.5027,
    y1: 112.569,
    x2: 118.129,
    y2: 108.802,
    stroke: "#EF476F",
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 92.3884,
    y1: 105.286,
    x2: 117.015,
    y2: 101.519,
    stroke: "#EF476F",
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 95.7302,
    y1: 127.135,
    x2: 115.606,
    y2: 124.095,
    stroke: "#EF476F",
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 57.3957,
    y1: 98.9714,
    x2: 74.4221,
    y2: 96.3674,
    stroke: "white",
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 57.6704,
    y: 109.944,
    width: 25.9475,
    height: 25.9475,
    rx: 3,
    transform: "rotate(-8.69553 57.6704 109.944)",
    fill: "#FFCAD7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.153 126.819C76.3846 126.22 75.4195 125.506 75.1436 123.701C74.978 122.619 75.7277 121.786 75.878 120.813C76.0282 119.84 76.0292 118.716 76.0474 117.895C76.0657 117.075 76.0742 116.757 76.0204 115.894C75.9513 114.817 74.8525 112.177 71.2213 112.732C67.5912 113.287 67.3295 116.135 67.5875 117.183C67.7942 118.023 67.8976 118.324 68.16 119.102C68.4224 119.879 68.7578 120.952 69.1917 121.836C69.6256 122.719 70.5912 123.29 70.7568 124.372C71.0328 126.177 70.3255 127.147 67.8624 128.545C65.3902 129.947 63.8369 131.195 63.9435 131.892L64.443 135.157L84.3924 132.106L83.893 128.841C83.7865 128.145 81.9304 127.419 79.153 126.819Z",
    fill: "#FF92AC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_24_13423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.328 99.8656C161.728 104.839 157.211 108.384 152.238 107.785L93.3617 100.691C88.3885 100.092 84.8429 95.5746 85.442 90.6015L89.1139 60.1243C89.7139 55.1511 94.2308 51.6055 99.204 52.2054L158.08 59.2991C163.053 59.8974 166.599 64.4152 166 69.3884L162.328 99.8656Z",
    fill: "#FFAABE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.158 91.8533L109.134 86.4281L109.219 85.7359L154.241 91.1603L154.158 91.8533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.657 96.0098L108.633 90.5846L108.717 89.8924L153.741 95.3168L153.657 96.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.355 92.5284L109.707 93.2289C109.799 93.4109 109.874 93.5779 109.953 93.7582L109.972 93.7598C110.094 93.5912 110.211 93.4474 110.331 93.2978L110.833 92.7062L111.426 92.7785L110.22 94.113L111.093 95.7998L110.469 95.725L110.108 94.9921C110.011 94.8027 109.931 94.6232 109.847 94.4288L109.834 94.4271C109.712 94.5958 109.587 94.7462 109.453 94.9124L108.935 95.5397L108.331 95.4674L109.588 94.0557L108.744 92.4544L109.355 92.5284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.241 92.877L112.593 93.5775C112.685 93.7595 112.759 93.9265 112.839 94.106L112.857 94.1085C112.98 93.9398 113.098 93.7952 113.217 93.6465L113.718 93.0548L114.312 93.1263L113.106 94.4616L113.979 96.1484L113.355 96.0728L112.994 95.3399C112.897 95.1505 112.817 94.971 112.734 94.7766L112.72 94.7757C112.599 94.9444 112.473 95.094 112.34 95.2602L111.821 95.8884L111.216 95.8152L112.474 94.4043L111.63 92.8031L112.241 92.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.127 93.2241L115.48 93.9254C115.572 94.1066 115.647 94.2744 115.726 94.4531L115.745 94.4564C115.867 94.2869 115.985 94.1423 116.104 93.9944L116.605 93.4027L117.198 93.4742L115.993 94.8087L116.866 96.4963L116.242 96.4207L115.881 95.6878C115.784 95.4984 115.704 95.3189 115.62 95.1245L115.607 95.1236C115.485 95.2915 115.36 95.4419 115.226 95.6081L114.708 96.2354L114.104 96.1623L115.361 94.7514L114.516 93.1501L115.127 93.2241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.014 93.5722L118.366 94.2727C118.459 94.4547 118.533 94.6217 118.613 94.8012L118.631 94.8037C118.753 94.6358 118.871 94.4913 118.991 94.3417L119.492 93.7501L120.085 93.8215L118.88 95.1568L119.753 96.8445L119.129 96.7689L118.767 96.0351C118.67 95.8465 118.591 95.6662 118.506 95.4726L118.494 95.4709C118.372 95.6396 118.247 95.7892 118.112 95.9562L117.595 96.5836L116.99 96.5104L118.247 95.0995L117.404 93.4983L118.014 93.5722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.9 93.9194L121.252 94.6199C121.345 94.8019 121.419 94.9689 121.498 95.1492L121.517 95.1517C121.639 94.983 121.758 94.8384 121.876 94.6897L122.378 94.0981L122.971 94.1687L121.766 95.504L122.638 97.1917L122.015 97.1169L121.654 96.3831C121.556 96.1937 121.478 96.0142 121.393 95.8206L121.379 95.8189C121.259 95.9868 121.133 96.1364 120.999 96.3042L120.48 96.9307L119.875 96.8576L121.134 95.4475L120.289 93.8455L120.9 93.9194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.786 94.2677L124.139 94.9681C124.23 95.1501 124.306 95.3171 124.386 95.4974L124.404 95.4991C124.526 95.3313 124.643 95.1867 124.764 95.0371L125.265 94.4455L125.857 94.5169L124.651 95.8514L125.524 97.5391L124.901 97.4643L124.54 96.7306C124.443 96.5419 124.363 96.3616 124.279 96.168L124.266 96.1664C124.145 96.335 124.019 96.4846 123.885 96.6516L123.367 97.279L122.763 97.2059L124.02 95.7958L123.176 94.1937L123.786 94.2677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.516 95.8633L127.467 96.2671L125.927 96.0826L125.976 95.6763L127.516 95.8633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.549 94.8413L128.902 95.5418C128.994 95.7237 129.068 95.8908 129.148 96.0711L129.166 96.0727C129.288 95.9049 129.407 95.7603 129.526 95.6116L130.027 95.0191L130.62 95.0906L129.415 96.4259L130.288 98.1135L129.664 98.0379L129.302 97.3042C129.206 97.1156 129.126 96.9353 129.041 96.7416L129.029 96.74C128.908 96.9087 128.782 97.0582 128.648 97.2253L128.13 97.8526L127.525 97.7795L128.783 96.3694L127.938 94.7673L128.549 94.8413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.435 95.1893L131.787 95.8898C131.879 96.0717 131.954 96.2388 132.034 96.4191L132.051 96.4207C132.174 96.2521 132.292 96.1083 132.411 95.9587L132.913 95.3671L133.506 95.4386L132.301 96.7731L133.173 98.4607L132.55 98.3859L132.189 97.6522C132.091 97.4636 132.012 97.2833 131.928 97.0896L131.915 97.088C131.794 97.2567 131.668 97.4062 131.534 97.5732L131.015 98.2006L130.411 98.1275L131.668 96.7174L130.825 95.1153L131.435 95.1893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.322 95.5371L134.674 96.2376C134.766 96.4195 134.841 96.5866 134.921 96.7669L134.939 96.7685C135.061 96.6007 135.179 96.4561 135.299 96.3074L135.801 95.7149L136.393 95.7872L135.188 97.1217L136.06 98.8093L135.437 98.7337L135.075 98.0008C134.978 97.8114 134.899 97.6311 134.814 97.4374L134.802 97.4358C134.681 97.6053 134.555 97.754 134.42 97.9211L133.902 98.5484L133.298 98.4761L134.556 97.0652L133.711 95.464L134.322 95.5371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.209 95.8843L137.561 96.5856C137.653 96.7675 137.727 96.9346 137.807 97.1149L137.825 97.1165C137.947 96.9479 138.065 96.8041 138.185 96.6545L138.686 96.0629L139.279 96.1352L138.074 97.4697L138.946 99.1565L138.323 99.0817L137.962 98.3488C137.865 98.1594 137.784 97.9791 137.701 97.7854L137.688 97.7838C137.567 97.9525 137.44 98.1029 137.307 98.2691L136.789 98.8964L136.184 98.8241L137.441 97.4124L136.598 95.8111L137.209 95.8843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.094 96.2332L140.446 96.9337C140.538 97.1157 140.613 97.2827 140.693 97.4622L140.711 97.4647C140.833 97.296 140.951 97.1514 141.071 97.0027L141.572 96.4111L142.165 96.4825L140.96 97.8178L141.832 99.5046L141.208 99.429L140.848 98.6961C140.75 98.5067 140.671 98.3272 140.587 98.1328L140.573 98.1319C140.452 98.3006 140.327 98.4502 140.193 98.6164L139.674 99.2446L139.069 99.1714L140.327 97.7605L139.483 96.1593L140.094 96.2332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 72.5307C159.653 75.3999 157.048 77.4457 154.178 77.0992L125.086 73.5943C122.218 73.2486 120.172 70.6428 120.518 67.7736C120.863 64.9035 123.469 62.8585 126.339 63.2042L155.43 66.71C158.3 67.0556 160.346 69.6615 160 72.5307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.676 76.5564L146.906 76.2232L148.157 65.8323L150.928 66.1663L149.676 76.5564Z",
    fill: "#031A6B",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.828 75.9729L140.672 75.4718L141.924 65.0826L146.079 65.5828L144.828 75.9729Z",
    fill: "#031A6B",
    fillOpacity: 0.06
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 94.1362,
    y: 58.844,
    width: 11.401,
    height: 11.401,
    rx: 2,
    transform: "rotate(4.64321 94.1362 58.844)",
    fill: "#FFC73D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.651 64.9522L105.438 60.8745L104.735 69.3113C104.641 70.4336 103.64 71.2574 102.521 71.133L96.6999 70.4862L101.651 64.9522Z",
    fill: "#FFEFC7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 93.9634,
    y: 60.9746,
    width: 11.401,
    height: 0.712563,
    transform: "rotate(4.64321 93.9634 60.9746)",
    fill: "#D9D9D9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 93.7905,
    y: 63.1052,
    width: 11.401,
    height: 0.712563,
    transform: "rotate(4.64321 93.7905 63.1052)",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.545 64.4501C101.418 66.0191 100.36 67.2135 99.1836 67.1179C98.0069 67.0224 97.1563 65.673 97.2837 64.104C98.8817 64.2337 98.2376 64.1815 99.4144 64.2771C100.591 64.3726 100.213 64.3419 101.545 64.4501Z",
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.893 63.6821C100.765 65.2511 100.026 66.4714 99.2415 66.4077C98.457 66.3439 97.9243 65.0204 98.0518 63.4514C99.1171 63.5379 98.6877 63.5031 99.4722 63.5668C100.257 63.6305 100.005 63.61 100.893 63.6821Z",
    fill: "#FFC73D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_24_13423)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.7617,
    y: 136.486,
    width: 98.894,
    height: 19.6502,
    transform: "rotate(-45 99.7617 136.486)",
    fill: "#EF476F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.887,
    y: 64.8098,
    width: 102.272,
    height: 21.0341,
    transform: "rotate(45 112.887 64.8098)",
    fill: "#EF476F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24_13423",
    x: 46.8305,
    y: 82.5972,
    width: 87.3877,
    height: 64.8565,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.61207
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.61207
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_13423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_13423",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_24_13423",
    x: 80.1518,
    y: 52.1392,
    width: 91.1382,
    height: 66.1604,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.22414
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.61207
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_13423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_13423",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_24_13423",
    x: 78.0137,
    y: 64.8098,
    width: 127.191,
    height: 127.191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.793333 0 0 0 0 0.793333 0 0 0 0 0.85 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_13423"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678819 0 0 0 0 0.686198 0 0 0 0 0.708333 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_24_13423",
    result: "effect2_dropShadow_24_13423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_24_13423",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditFailed);
export default __webpack_public_path__ + "static/media/credit-failed.7ed1e57328937910ed9d0fcc652ca085.svg";
export { ForwardRef as ReactComponent };